import Vue from 'vue'

// import {interval} from './tools/interval'

import {candidateNominationDayUrl, constituenciesInfo, partyColor, partyNames, constituencyTypes} from './tools/variables'

const store = Vue.observable({
  candidates: {},
  constituencies: {},
  parties: {},
  currentConstituency: null,
  currentCandidate: null,
  showPopUp: false
})

let lastCandidateNominationDayDatas = null

const hasNewData = (oldDatas, newDatas) => {
  const keyChanges = [
    'candidate_name',
    'party',
    'constituency',
    'current-constituency',
    'leader',
    'no-of-terms',
    'photos-ok',
    'ready'
  ]

  return !oldDatas || newDatas.some((d, i) => {
    return keyChanges.some(key => oldDatas[i][key] !== d[key])
  })
}

const fetchData = () => {
  const candidates = {}
  const parties = {}
  const constituencies = {}

  Promise.all([
    fetch(candidateNominationDayUrl).then(res => res.json())
  ]).then(([candidateNominationDayDatas]) => {
    console.log('bio ready', candidateNominationDayDatas[1].biodataready)
    const biodataready = candidateNominationDayDatas[0].biodataready
    store.showPopUp = biodataready && biodataready === 'Y'
    if (!hasNewData(lastCandidateNominationDayDatas, candidateNominationDayDatas)) return

    console.log('ge2020 candidate data changed, update data...')
    lastCandidateNominationDayDatas = candidateNominationDayDatas

    const walkoverConstituencies = {}
    if (candidateNominationDayDatas[0].walkover) {
      candidateNominationDayDatas[0].walkover.split(',').forEach(constituencyName => {
        walkoverConstituencies[constituencyName.trim()] = true
      })
    }

    Object.keys(constituenciesInfo).forEach(cn => {
      const constituencyName = cn.trim()
      const {mp, former_incumbant_party} = constituenciesInfo[constituencyName]
      if (!constituencies[constituencyName]) {
        constituencies[constituencyName] = {
          name: constituencyName,
          winner: null,
          seats: parseInt(mp),
          typeString: parseInt(mp) === 1 ? 'SMC' : `${mp}-member GRC`,
          typeStringLong: constituencyTypes[mp],
          incumbentKey: former_incumbant_party,
          parties: {},
          walkover: walkoverConstituencies[constituencyName]
        }
      }
    })

    candidateNominationDayDatas
      .filter(d => d.candidate_name && d.ready === 'Y')
      .forEach(d => {
        const constituencyName = d.constituency.trim()
        const candidateKey = d.id + '-' + d.candidate_name
        candidates[candidateKey] = {}
        Object.keys(d).forEach(key => {
          candidates[candidateKey][key] = d[key]
          if (typeof d[key] === 'string') {
            candidates[candidateKey][key] = d[key].trim()
          }
        })

        if (!candidates[candidateKey].id) candidates[candidateKey].id = 0
        if (!candidates[candidateKey].key) candidates[candidateKey].key = candidates[candidateKey].id + '+' + candidates[candidateKey].candidate_name.replace(/ /g, '_')

        if (candidates[candidateKey].newcomer === 'Y') {
          candidates[candidateKey]['no-of-terms'] = 0
        } else if (!candidates[candidateKey]['no-of-terms'] || isNaN(candidates[candidateKey]['no-of-terms'])) {
          candidates[candidateKey]['no-of-terms'] = 0
        }

        const partyKey = d.party.trim()
        if (!parties[partyKey]) {
          parties[d.party] = {
            members: {},
            key: partyKey,
            name: partyNames[partyKey] || partyKey,
            initial: partyNames[partyKey] ? partyKey : 'IND',
            color: partyColor[d.party] || partyColor['IND'],
            leader: null,
            contestedConstituencies: {}
          }
        }

        if (d.leader === 'Y') {
          parties[partyKey].leader = candidates[candidateKey]
        }

        if (!parties[partyKey].members[constituencyName]) parties[partyKey].members[constituencyName] = []
        parties[partyKey].members[constituencyName].push(candidates[candidateKey])
        // parties[partyKey].members[constituencyName].sort((a, b) => (a['no-of-terms'] || 0) - (b['no-of-terms'] || 0))

        if (!constituencies[constituencyName].parties[partyKey]) {
          constituencies[constituencyName].parties[partyKey] = parties[partyKey]
        }

        if (!parties[partyKey].contestedConstituencies[constituencyName]) {
          parties[partyKey].contestedConstituencies[constituencyName] = constituencies[constituencyName]
        }
      })

    Object.keys(parties).forEach(partyKey => {
      const party = parties[partyKey]
      Object.keys(party.members).forEach(constituencyName => {
        const leaders = party.members[constituencyName]
          .filter(m => m.leader === 'Y')
          .sort((a, b) => b['no-of-terms'] - a['no-of-terms'])

        const newcomers = party.members[constituencyName]
          .filter(m => m.newcomer === 'Y' && m.leader !== 'Y')

        const members = party.members[constituencyName]
          .filter(m => m.leader !== 'Y' && m.newcomer !== 'Y')
          .sort((a, b) => b['no-of-terms'] - a['no-of-terms'])

        party.members[constituencyName] = [...leaders, ...members, ...newcomers]
      })
    })

    store.candidates = candidates
    store.constituencies = constituencies
    store.parties = parties
  })
} // fetchData

fetchData()

// interval(fetchData, 10)
export {store}
